import { InputRange } from '../../../components/InputRange';
import { FormField } from '../../../components/FormField';
import { RoundedBox } from '../../../components/Shared/RoundedBox';
import { OverLay } from '../../../components/OverLay';

export const Delivery = () => {
    return (
        <OverLay text="On development stage" textClassName="text-3xl">
            <div className="grid grid-cols-2 gap-4">
                <RoundedBox title="Delivery Zones" description="Draw your delivery zone in the map below and confirm the radius or manually enter the maximum radius you would like to offer delivery using the toggle below">
                    <FormField label="Max delivery radius" labelStyle="mb-3 inline-flex">
                        <div className="flex items-end gap-5">
                            <InputRange width="w-9/12" handleChange={() => {}} value={10} />
                            <span className="text-sm font-medium text-gray-900">1.5 miles</span>
                        </div>
                    </FormField>
                    <FormField label="Draw on map" labelStyle="mt-5 mb-3 inline-flex">
                        <div className="flex items-center justify-center h-80 bg-gray-50">Map</div>
                    </FormField>
                </RoundedBox>
                <RoundedBox title="Driver List" description="Add or edit you delivery driver list">
                    <div className="flex flex-col gap-1">
                        <div className="flex justify-between rounded shadow-md bg-white p-4">
                            <span>Name</span>
                            <span>Icon</span>
                        </div>
                        <div className="flex justify-between rounded shadow-md bg-white p-4">
                            <span>Name</span>
                            <span>Icon</span>
                        </div>
                        <div className="flex justify-between rounded shadow-md bg-white p-4">
                            <span>Name</span>
                            <span>Icon</span>
                        </div>
                    </div>
                </RoundedBox>
            </div>
        </OverLay>
    );
};
